<template>
	<div class="RePlace">
		<div class="d-flex btn-group btn-group-toggle mb-3 w-100" data-toggle="buttons">
			<label
				v-for="(option, index) in tabs.tabView"
				:key="option.name"
				class="btn btn-sm btn-primary btn-simple"
				:class="{ active: tabs.activeIndexView === index }"
				:id="index"
			>
				<input
					type="radio"
					@click="initTabView(index)"
					name="options"
					autocomplete="off"
					:checked="tabs.activeIndexView === index"
				/>
				<span class="d-none d-sm-block">{{ option.name }}</span>
				<span class="d-block d-sm-none"><i :class="option.icon"></i></span>
			</label>
		</div>
		<card>
			<div class="tabContainer">
				<div v-show="tabs.activeIndexView == 0" class="placeTab"><ReSelectDistrict v-model="value.districts"/></div>
				<div v-show="tabs.activeIndexView == 1" class="placeTab"><ReSelectDirection v-model="value.directions" /></div>
				<div v-show="tabs.activeIndexView == 2" class="placeTab"><ReSelectMetro v-model="value.metro" /></div>
				<div v-show="tabs.activeIndexView == 3" class="placeTab"><ReSelectMap v-model="value.map" /></div>
			</div>
		</card>
		<div class="btnGroup" v-if="typeof objSaveApiMethod !='undefined'">
			<button class="btn btn-simple btn-success" @click="onSave()">Сохранить</button>
			<button class="btn btn-simple btn-danger" @click="onCancel()">Отменить</button>
		</div>
	</div>
</template>

<script>
	import ReSelectMetro from "src/our_components/ReSelectMetro.vue";
	import ReSelectDistrict from "src/our_components/ReSelectDistrict.vue";
	import ReSelectDirection from "src/our_components/ReSelectDirection.vue";
	import ReSelectMap from "src/our_components/ReSelectMap.vue";
	export default {
		name: 'RePlace',
		components: {
			ReSelectMetro,
			ReSelectDistrict,
			ReSelectDirection,
			ReSelectMap,
		},
		props: {
			value: {
				type: Object,
				default(){
					return {
						districts: {all:[]},
						directions: {all: []},
						metro: {all:[]},
						map: {}
					}
				}
			},
			objSaveApiMethod: Object,
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				tabs: {
					activeIndexView: 0,
					tabView: [
						{ name: "Район", icon: "tim-icons icon-atom" },
						{ name: "Направление", icon: "tim-icons icon-double-right" },
						{ name: "Метро", icon: "tim-icons icon-bus-front-12" },
						//{ name: "Карта", icon: "tim-icons icon-square-pin" },
					]
				},
			}
		},
		computed: {

		},
		methods: {
			initTabView(index) {
				this.tabs.activeIndexView = index;
			},
			onSave(){

			},
			onCancel(){

			},
		},
	}
</script>
<style scoped>
	.card{
		margin-bottom: 15px;
	}
	.btnGroup {
		display: flex;
		justify-content: space-around;
	}
	.tabContainer{
		height: 320px;
		overflow-y: auto;
	}
</style>
